import { components } from 'type/ReportServiceSchema';
import { Question } from 'model/Question';
import { Benchmark } from 'model/Benchmark';
import { Trend } from 'model/Trend';

export type FocusAreaDto = components['schemas']['FocusArea'];

export type FocusAreasDto = components['schemas']['FocusAreas'];

export type FocusAreaModel = {
  id: number;
  qlId: string | null;
  text: string;
  isPositive: boolean;
};

export type FocusAreasModel = {
  userId: string;
  userEmail: string;
  focusAreas: FocusAreaModel[];
};

export const mapFocusAreaDtoToModel = (dto: FocusAreaDto): FocusAreaModel => ({
  id: dto.id,
  qlId: dto.qlId,
  text: dto.text,
  isPositive: dto.isPositive,
});

export const mapFocusAreasDtoToModel = (dto: FocusAreasDto): FocusAreasModel => ({
  userId: dto.userId,
  userEmail: dto.userEmail,
  focusAreas: dto.focusAreas.map(mapFocusAreaDtoToModel),
});

export type FocusAreaWithEngagementDriverMetricsModel = FocusAreaModel & {
  question: Question | null;
  score: number | null;
  benchmark: Benchmark;
  categoryTitle: string | null;
  trends: Trend[] | null;
  impactOnEngagementScore: number | null;
};

export type FocusAreasWithEngagementDriverMetricsModel = Omit<FocusAreasModel, 'focusAreas'> & {
  focusAreas: FocusAreaWithEngagementDriverMetricsModel[];
};
